import { useEffect, useState } from "react";
import { faqAnchors } from "./helpPage.data";

const useHelpFaqAnchor = (hash: string) => {
  const [activeKey, setActiveKey] = useState<string | string[]>("");

  useEffect(() => {
    const key = faqAnchors[hash];

    if (!key) {
      return;
    }

    let animationFrame = 0;
    let isCancelled = false;
    let stableFrames = 0;
    let previousScrollY = window.scrollY;
    const anchorId = hash.slice(1);

    setActiveKey("");

    const openAfterScrollSettles = () => {
      if (isCancelled) {
        return;
      }

      const anchor = document.getElementById(anchorId);
      if (!anchor) {
        return;
      }

      const rect = anchor.getBoundingClientRect();
      const isVisible = rect.top >= 96 && rect.bottom <= window.innerHeight - 24;
      const hasStopped = Math.abs(window.scrollY - previousScrollY) < 1;

      stableFrames = isVisible && hasStopped ? stableFrames + 1 : 0;
      previousScrollY = window.scrollY;

      if (stableFrames >= 5) {
        setActiveKey(key);
        return;
      }

      animationFrame = window.requestAnimationFrame(openAfterScrollSettles);
    };

    animationFrame = window.requestAnimationFrame(() => {
      const anchor = document.getElementById(anchorId);
      if (!anchor || isCancelled) {
        return;
      }

      anchor.scrollIntoView({ behavior: "smooth", block: "center" });
      animationFrame = window.requestAnimationFrame(openAfterScrollSettles);
    });

    return () => {
      isCancelled = true;
      window.cancelAnimationFrame(animationFrame);
    };
  }, [hash]);

  return { activeKey, setActiveKey };
};

export default useHelpFaqAnchor;
